import React from 'react';
import Dropdown from 'react-toolbox/lib/dropdown';
import ValidatedInput
  from '../../../../../../../common/components/ValidatedInput';
import { FormSubHeader, noteStyle } from '../styles';
import { scenarioHandlers } from './utils';
import styles from './styles.css';

const optionsToDropDown = value => ({
  value: value.replace(/\s+/g, ''),
  label: value,
});

// TODO: find somewhere better for these kinds of constants
const PrefixOptions = ["None", "Mr",
        "Mrs",
        "Ms",
        "Miss",
        "Dr",
        "Col",
        "Governor",
        "LT Gov",
        "Senator",
        "Rep"];
const PrefixSource = PrefixOptions.filter(prefix => prefix !== 'None').map(
  optionsToDropDown
);

export default {
  personalSubHeader: {
    component: FormSubHeader,
    children: 'Enter Personal Information',
    readOnly: true,
  },
  prefix: {
    component: Dropdown,
    hide: scenarioHandlers.knownCustomer,
    label: 'Prefix',
    source: PrefixSource,
    required: true,
    className: styles.themedDropdown,
  },
  firstName: {
    component: ValidatedInput,
    disable: scenarioHandlers.knownCustomer,
    label: 'First Name',
    validation: [
      {
        checkValid: value => (value || '').length <= 30,
        message: 'First name must not exceed 30 characters.',
        events: ['onChange'],
      },
      {
        pattern: /^[a-z\-\s.]*$/i,
        message: 'Valid names can contain letters, a hyphen, and a period.',
        events: ['onChange'],
      },
    ],
    required: true,
    maxLength: 30,
    counter: true,
  },
  lastName: {
    component: ValidatedInput,
    disable: scenarioHandlers.knownCustomer,
    label: 'Last Name',
    validation: [
      {
        checkValid: value => (value || '').length <= 30,
        message: 'First name must not exceed 30 characters.',
        events: ['onChange'],
      },
      {
        pattern: /^[a-z\-\s.]*$/i,
        message: 'Valid names can contain letters, a hyphen, and a period.',
        events: ['onChange'],
      },
    ],
    required: true,
    maxLength: 30,
    counter: true,
  },
  organizationName: {
    component: ValidatedInput,
    disable: scenarioHandlers.knownCustomer,
    label: 'Organization Name',
    validation: [
      {
        checkValid: value => (value || '').length <= 30,
        restrictInput: true,
        events: ['onChange'],
      },
    ],
    maxLength: 30,
    showCounter: data => !scenarioHandlers.knownCustomer(data),
  },
  orgNameTip: {
    component: props => <span {...props} />,
    readOnly: true,
    hide: scenarioHandlers.newCustomer,
    children: '*If this is not your organization name, please contact Member Care at 1-800-NFIB-NOW.',
    style: {
      ...noteStyle,
      paddingBottom: '2rem',
      position: 'relative',
      bottom: '2rem',
    },
  },
  badgeName: {
    component: ValidatedInput,
    validation: [],
    hide: scenarioHandlers.remoteEvent,
    label: 'Event Badge Name',
    required: true,
    maxLength: 130,
    counter: true,
  },
};



// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/RegistrationCard/RegistrationForm/FieldConfig/personalDetails.js